import { createRouter, createWebHistory } from 'vue-router'
import Portfolio from '../views/Portfolio.vue'
import Settings from '../views/Settings.vue'
import Toplist from '../views/Toplist.vue'
import TradingCentre from '../views/TradingCentre.vue'
import Login from '../views/Login.vue'
import BidAskStock from '../views/BidAskStock.vue'

const routes = [
  {
    path: '/portfolio/:uid',
    name: 'Portfolio',
    component: Portfolio,
  },
  {
    path: '/settings/:uid',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/toplist/:uid',
    name: 'Toplist',
    component: Toplist
  },
  {
    path: '/tradingcentre/:uid',
    name: 'TradingCentre',
    component: TradingCentre
  },
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/BidAskStock/:stock/:uid',
    name: 'BidAskStock',
    component: BidAskStock
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
